export default "__VITE_ASSET__DzmCGSGB__"